import { render, staticRenderFns } from "./Quejas.vue?vue&type=template&id=1fcefab0"
import script from "./Quejas.vue?vue&type=script&lang=js"
export * from "./Quejas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports